import React, { useRef, useEffect, useCallback } from "react";

function useNextTick() {
  const timerRef = useRef<Timeout>(null);
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current!);
        timerRef.current = null;
      }
    };
  }, []);

  return useCallback((fn: () => any, delay?: number) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      fn && fn();
    }, delay || 100);
  }, []);
}

export default useNextTick;
